module.exports = __webpack_public_path__ + "img/1571432237.de4531eb.jpg";